<style scoped>
    @import url("../../styles/smartControl/rSmartControl.scss");
</style>

<template>
    <div class="box_rSC">

        <!-- Se estiver travando a entrada, colocar um loading com flag condicionado a 1a req rcv -->

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-update</v-icon>
            <span class="ml-2">Recente</span>
        </div>

        <div class="painelGeral" v-if="flagMsgSistema">
            <span>{{ msgSistema }}</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <!-- INDICES -->
        <div class="painelGeral" v-if="!flagMsgSistema">

            <div class="titPainel">
                <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-poll</v-icon>
                <span class="ml-2">Índices</span>
            </div>

            <div class="contentPainel">
                
                <div v-if="(liParamExib_i.length < 1) && flagExib_i"
                :style="{'font-size':'0.8rem'}">Nenhum índice habilitado.</div>

                <ExibText v-for="(el,j) in liParamExib_i" :key="j"
                :index="j"
                :t="el.titulo" 
                :unid="el.unidade" 
                :iconEl="el.icon" 
                :name_key="el.sub_marcador"
                :device="el.device"
                
                :cliente="$store.state.emailCliente" 
                :sistema="$store.state.sistemaSC"

                :r="r3" 
                />
            </div>
        </div>

        <!-- SENSORES -->
        <div class="painelGeral" v-if="!flagMsgSistema">

            <div class="titPainel">
                <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-chart-line</v-icon>
                <span class="ml-2">Sensores</span>
            </div>

            <div class="contentPainel">

                <div v-if="(liParamExib.length < 1) && flagExib_i"
                :style="{'font-size':'0.8rem'}">Nenhum sensor habilitado.</div>

                <ExibText v-for="(el,i) in liParamExib" :key="i"
                :index="i"
                :t="el.titulo" 
                :unid="el.unidade" 
                :iconEl="el.icon" 
                :name_key="el.sub_marcador"
                :device="el.device"
                :deviceStatus="el.status"
                
                :cliente="$store.state.emailCliente" 
                :sistema="$store.state.sistemaSC"

                :r="r3" 
                />
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

import ExibText from './ExibText'

export default {

    components:{ ExibText },

    data() {
        return {
            //
            r3:'/lastreadingorange',

            // lista para o loop de exibição
            liParamExib:[], // sensores (normalmente leituras brutas)
            liParamExib_i:[], // indices (valores calculados)
            flagExib_i:false, // true quando termina de preencher a lista indice

            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.
            msgSistema:'Selecione um sistema na página "Início"',
        }
    },

    methods:{

        preInit() {

            this.sistema = this.$store.state.sistemaSC // v2 14/08/2025
            let cl = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':cl, 'sistema':this.sistema}

            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log('recentesSC.vue')
                //console.log(res.data.result)

                const el = res.data.result // agent_unit
                let liSensores = el['sensores']
                let liIndices = el['indices']

                //let local_liParamExib = [] // tmp save
                let c=0
                while (c < liSensores.length) {
                    let device = liSensores[c]['device'] // device name
                    let liParams = liSensores[c]['params'] // lista de params do sensor
                    let j=0
                    while (j < liParams.length) {
                        liParams[j]['device'] = device // criando nova key em cada dict [j]
                        self.liParamExib.push(liParams[j])
                        //local_liParamExib.push(liParams[j])
                        j++
                    }
                    c++
                }

                c=0
                while (c < liIndices.length) {
                    let device = liIndices[c]['device'] // device name
                    let liParams = liIndices[c]['params'] // lista de params do sensor
                    let j=0
                    while (j < liParams.length) {
                        liParams[j]['device'] = device // criando nova key em cada dict [j]
                        self.liParamExib_i.push(liParams[j])
                        //local_liParamExib_i.push(liParams[j])
                        j++
                    }
                    c++
                }
                self.flagExib_i = true

                //self.liParamExib = [local_liParamExib[0]] // apenas o 1o elemento para testar
                //console.log('self.liParamExib: ',self.liParamExib)
                //console.log('self.liParamExib [tam]: ',self.liParamExib.length)
            })
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { 
            this.flagMsgSistema = false 

            if (execSys != 'aveleda1') { this.preInit() } // nao ha dados recentes para o POC 2023
            else { 
                this.msgSistema = 'Dados recentes indisponíveis para este sistema'
                this.flagMsgSistema = true
            } 
        }
    }
}
</script>